export default {
  watch: {
    totalSelected(val) {
      if (val === this.dataPeriodicallyCareTable.data.length) {
        this.filterForm.checkboxAll = true;
      } else {
        this.filterForm.checkboxAll = false;
      }
    },
    'dataPeriodicallyCareTable.data.length': function () {
      this.totalSelected = 0;
      this.filterForm.checkboxAll = false;
    },
    // eslint-disable-next-line func-names
    // dataPeriodicallyCareTable: {
    //   handler() {
    //     this.totalSelected = 0;
    //     this.filterForm.checkboxAll = false;
    //   },
    //   deep: true,
    // },
    'filterForm.page': function () {
      this.filterForm.checkboxAll = false;
      this.totalSelected = 0;
    },
  },
};
